<script>
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

export default {
  mixins: [apibtoast, apigeneric],
  props: ["Id","Dosyaid","SiradakiNo" ],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: {},
      TableData: [],
      SecilenMalzemeler:[],
      Olcubirimleri:[],
      tumunusec:false,
      talepdata:{},
      satmalzeme:{}
    };
  },
  components: {

  },
  watch: {
    Id() {
     
      this.Get();
      
    },
  },
  methods: {

    kayit_sec(malzeme){

      var varmi=this.SecilenMalzemeler.indexOf(malzeme);
 
      if (varmi<0){
      this.SecilenMalzemeler.push(malzeme);
      } else {
        this.SecilenMalzemeler.splice(varmi,1);
        
      }

      if (this.SecilenMalzemeler.length==0){this.tumunusec=false;}

    },

    tumunu_sec(){
      this.SecilenMalzemeler=[];
      if (this.tumunusec==false){

          for ( var i=0; i<this.TableData.length; i++){
              this.TableData[i].checked=true;
          }
          for ( i=0; i<this.TableData.length; i++){
             this.SecilenMalzemeler.push(this.TableData[i]);    
          }

      } else {
          for ( i=0; i<this.TableData.length; i++){
            this.TableData[i].checked=false;  
          }
           this.SecilenMalzemeler=[];
           this.tumunusec=false;
          }  

    },


    tek_aktar(data) {

      this.talepdata={};
     
      this.talepdata=JSON.parse(JSON.stringify(data));


        let Filter = "&Dosyaid="+this.Dosyaid+"&Malzemeid="+this.talepdata.Malzemeid;
        this.ActionsFilterGet({Service:"SatDosyaMalzeme",Page:this.Page,Filter:Filter}).then(res => { 

          this.satmalzeme=res.Data;

          if (this.satmalzeme.length>0){

            let toplam=this.satmalzeme[0].Adet + this.talepdata.Adet;
            this.satmalzeme[0].Adet=toplam;

            this.Update("SatDosyaMalzeme", this.satmalzeme[0],false).then((res) => {
                if (res) {

                  this.talepdata.Satdosyamalzemeid=this.satmalzeme[0].Id;
                  this.talepdata.Onaydurum=4;
                  this.Update("SatTalepMalzeme", this.talepdata,"Malzeme Eklendi").then((res) => {
                      if (res) {
                                        
                      this.talep_kontrol();
                        this.Get();
                      
                      } 
                  });

                }
            });
           

          } else {

            data.Sirano=this.SiradakiNo;

            this.$delete(data, "Id");             
       
            this.Post("SatDosyaMalzeme",data,false).then((res) => {
              if (res) {
            
                  this.talepdata.Satdosyamalzemeid=res;
                  this.talepdata.Onaydurum=4;
                  this.Update("SatTalepMalzeme", this.talepdata,"Malzeme Eklendi").then((res) => {
                      if (res) {
                                          
                        this.talep_kontrol();
                          this.Get();
                        this.SiradakiNo=this.SiradakiNo+1;
                        this.$emit("TableUpdate");
                      }
                  });
              }
            });     

          }


        });

  
        


          
    },

    tek_reddet(data) {
   
        data.Onaydurum=2;
        this.Update("SatTalepMalzeme", data,"Malzeme Reddedildi").then((res) => {
            if (res) {
                            
                this.talep_kontrol();
                this.Get();
            }
        });

      
          
    },

    toplu_aktar(data) {

            this.talepdata={};
     
            this.talepdata=JSON.parse(JSON.stringify(data[0]));


              let Filter = "&Dosyaid="+this.Dosyaid+"&Malzemeid="+this.talepdata.Malzemeid;
              this.ActionsFilterGet({Service:"SatDosyaMalzeme",Page:this.Page,Filter:Filter}).then(res => { 
                if (res){

                    this.satmalzeme=res.Data;

                    if (this.satmalzeme.length>0){

                      let toplam=this.satmalzeme[0].Adet + this.talepdata.Adet;
                      this.satmalzeme[0].Adet=toplam;

                      this.Update("SatDosyaMalzeme", this.satmalzeme[0],false).then((res) => {
                          if (res) {

                            this.talepdata.Satdosyamalzemeid=this.satmalzeme[0].Id;
                            this.talepdata.Onaydurum=4;
                            this.Update("SatTalepMalzeme", this.talepdata,false).then((res) => {
                                if (res) {
                                                  
                                this.talep_kontrol();

                                data.splice(0,1);

                                   if (data.length>0){
                                      this.toplu_aktar(data)
                                    } else {
                                      this.$toast.success("Malzemeler Eklendi");
                                    }                                 
                                
                                } 
                            });

                          }
                      });
                    

                    } else {

                    // console.log(data[i]);

                    data[0].Sirano=this.SiradakiNo;

                      this.$delete(data[0], "Id");          
                
                      this.Post("SatDosyaMalzeme",data[0],false).then((res) => {
                        if (res) {
                      
                            this.talepdata.Satdosyamalzemeid=res;
                            this.talepdata.Onaydurum=4;
                            this.Update("SatTalepMalzeme", this.talepdata,false).then((res) => {
                                if (res) {
                                                    
                                  this.talep_kontrol();

                                    data.splice(0,1);

                                    if (data.length>0){
                                       this.SiradakiNo=this.SiradakiNo+1;
                                      this.toplu_aktar(data)
                                    }else {
                                      this.$toast.success("Malzemeler Eklendi");
                                    }
                                  
                                }
                            });
                        }
                      });     

                    }

                }


              });
               
    

    },


    toplu_reddet(data) {


          for (var i=0; i<data.length;i++){
              data[i].Onaydurum=2;               
          }

          this.ActionsPutList({   Service: "SatTalepMalzeme/PutList",  Data: data}).then((res) => {
              if (res) {

                this.$toast.success("Seçilen Malzemeler Reddedildi"); 
                
                 this.talep_kontrol();
                 this.Get();
              }
          });
          
    },

    talep_kontrol(){
     
       this.ActionsFilterGet({ Service: "SatTalepMalzeme", Page: this.Page,
       Filter: "&Talepid=" + this.Id+"&Onaydurum=3", }).then((res) => {
            if(res.Data.length==0){
              this.ActionsSingleGet({ Service: "SatTalep", Id: this.Id }).then((res) => {
                this.Update("SatTalep", {"Id":this.Id, "Onaydurum":6, "Birimid": res.Data.Birimid},false).then((res) => {
                    if(res){
                        this.$emit("TableUpdate");
                    }
                });
              });
                      
            }
              
        });

    },

    Get() {

        this.ActionsFilterGet({
          Service: "SatTalepMalzeme",
          Page: this.Page,
          Filter: "&Talepid=" + this.Id+"&Onaydurum=3",
        }).then((res) => {
          this.TableData = res.Data;
          for (var i=0; i<this.TableData.length; i++){
            
             this.TableData[i].Dosyaid=this.Dosyaid;
             this.TableData[i].TalepMalzemeId=this.TableData[i].Id; 

            this.$delete(this.TableData[i], "Satdosyamalzemeid");  
       
             this.$delete(this.TableData[i], "Sirano"); 
             this.$delete(this.TableData[i], "Depokarsilananadet"); 
             this.$delete(this.TableData[i], "Onaydurum");                       

          }
        });

        this.ActionsSabitGet(201).then(res => {  
          this.Olcubirimleri=[];
          for(var i=0; i<res.Data.length; i++)
            {
              this.Olcubirimleri.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
            }    
        }); 
    
    },

    TumunuKarsila() {
      for (var i = 0; i < this.TableData.length; i++) {
        this.TableData[i].Depokarsilananadet = this.TableData[i].Adet;
        this.$delete(this.TableData[i], "Id");  
        this.TableData[i].Onaydurum = 1;
      }
    },

    TumunuKarsilaIptal() {
      for (var i = 0; i < this.TableData.length; i++) {
        this.TableData[i].Depokarsilananadet = 0;
        this.TableData[i].Onaydurum = 0;
      }
    },

  },
};
</script>
<template>
  <div>


        <div class="table-responsive">
          <table class="table mb-0">
            <thead class="table-light">
              <tr>
                <th> <input type="checkbox" 
                @click="tumunu_sec()"
                v-model="tumunusec"
                 class="form-check-input" 
                 value="accepted" id="__BVID__362"></th>
                <th width="60%" rowspan="2">
                  {{$t('satinalmatalepleri.TableAlt.MalzemeAdi')}}
                </th>

                <th width="15%">
                  {{$t('satinalmatalepleri.TableAlt.Olcubirimi')}}
                  
                </th>
              
                <th width="15%">
                  {{$t('satinalmatalepleri.TableAlt.Adet')}}
                  
                </th>
      
                <th width="10%">
                 {{$t('satinalmatalepleri.TableAlt.islem')}}
                </th>
              </tr>
              <tr></tr>
            </thead>
            <tbody>
              <tr v-for="Data in TableData" :key="Data.Id">
                <th> 
        
                <input type="checkbox" 
                @click="kayit_sec(Data)"
                v-model="Data.checked"
                 class="form-check-input" 
                 value="accepted" id="__BVID__362">
                 </th>
                <th scope="row">{{ Data.Malzemeadi }}</th>
                  <th scope="row">
                <select
                      v-model="Data.Olcubirimi"
                      class="form-select"
                      type="text"
                    >
                      <option
                        v-for="birim in Olcubirimleri"
                        :key="birim.Id"
                        :value="birim.Id"
                      >
                        {{ birim.Value }} 
                      </option>
                </select>
                  </th>
            
                <th scope="row">
                  <input
                    v-model="Data.Adet"
                    type="number"
                    class="form-control"
                    min="1"
                 
                  />
                </th>
                
                <th >

                  <i v-tooltip="$t('satinalmatalepleri.TableAlt.Reddet')"
                   @click="tek_reddet(Data)"
                   class="fas fas fas fa-times">
                         
                  </i> 
            

                   <i style="padding-left: 20px" v-tooltip="$t('satinalmatalepleri.TableAlt.aktar')"
                   @click="tek_aktar(Data)"
                   class="fas fas fa-check-double">
                         
                      </i>
                
                 
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <button
         @click="toplu_aktar(SecilenMalzemeler)"
          class="btn btn-primary"
          type="submit"
        >
          {{ $t("satinalmatalepleri.TableAlt.Button") }}
        </button>

        <button style=" float: right;"
         @click="toplu_reddet(SecilenMalzemeler)"
          class="btn btn-danger"
          type="submit"
        >
          {{ $t("satinalmatalepleri.TableAlt.ButtonRed") }}
        </button>


  </div>
</template>
